import React from 'react';
import { FormContext } from '../contexts';
import { FieldProps } from '../interfaces';
import { FormMode } from '../enums';
import { getIdFromInputName, getValueByPath } from '../utils';

export const useGetFieldRules = <TProps extends FieldProps>(name?: string): TProps => {
  const { formRules, formMode, formState } = React.useContext(FormContext);

  const defaultStateValue = React.useMemo(() => {
    const value = getValueByPath(formState, name ?? '');
    return value !== null ? value : undefined;
  }, [name]);

  const contextRules: TProps = React.useMemo(() => {
    const rules: any = !!name ? formRules[name] : {};
    return {
      ...rules,
      id: rules?.id ? rules.id : getIdFromInputName(name ?? ''),
      defaultValue: rules?.defaultValue != null ? rules.defaultValue : defaultStateValue,
      disabled: formMode === FormMode.ReadOnly || !!rules?.disabled,
      name
    };
  }, [formRules, name, defaultStateValue]);
  return contextRules;
};
